import {Calendar} from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import slLocale from './lang/sl';
import hrLocale from './lang/hr';
import fiLocale from '@fullcalendar/core/locales/fi';
import svLocale from '@fullcalendar/core/locales/sv';
import itLocale from '@fullcalendar/core/locales/it';
import csLocale from '@fullcalendar/core/locales/cs';
import skLocale from '@fullcalendar/core/locales/sk';
import frLocale from '@fullcalendar/core/locales/fr';
import interactionPlugin, {Draggable} from '@fullcalendar/interaction';
import moment from 'moment';
import bsBreakpoints from 'bs-breakpoints';
import momentPlugin from '@fullcalendar/moment';
import tinymce from "tinymce";


import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';
import '@fullcalendar/timegrid/main.css';
import '@fullcalendar/list/main.css';
import {arrayIncludes} from "bootstrap-vue/esm/utils/array";

bsBreakpoints.init();

$(document).ready(function (e) {

    let defaultView = '',
        tasks = '',
        calendar_start_field = '',
        calendar_end_field = '',
        calendar_all_day_field = '',
        task_type = $('.toggle-calendar.checked').attr('data-type'),
        loaded_tasks = [],
        compactWeekView = false,
        calendar;

    let $page_container = $('.page-container'),
        table_id = $page_container.attr('data-table-id'),
        table_label = $page_container.attr('data-table-label'),
        locale = $('#calendar').attr('data-lang');

    let $body = $('body');

    let picker = flatpickr("#calendarDatePicker", {
        defaultDate: new Date(),
        enableTime: false,
        dateFormat: "Y-m-d",
        disableMobile: true,   // ← prevents native mobile date input
        onChange: function (selectedDates) {
            if (selectedDates.length) {
                let selectedDate = selectedDates[0];
                calendar.gotoDate(selectedDate);
            }
        },
        onOpen: function(selectedDates, dateStr, instance) {
          setTimeout(function() {
            let cal = instance.calendarContainer;
            let icon = document.querySelector('.calendar-picker-trigger');
            let iconRect = icon.getBoundingClientRect();
            let calWidth = cal.offsetWidth;

            let left = iconRect.left + (iconRect.width / 2) - (calWidth / 2);

            // Prevent going off left edge
            if (left < 8) left = 8;

            // Prevent going off right edge
            if (left + calWidth > window.innerWidth - 8) {
              left = window.innerWidth - calWidth - 8;
            }

            cal.style.position = "fixed";
            cal.style.top = (iconRect.bottom + 8) + "px";
            cal.style.left = left + "px";
            cal.style.right = "auto";
          }, 0);
        }
    });

    // Open picker on icon click
    $(document).on('click', '.calendar-picker-trigger', function () {
        picker.open();
    });

    let $quickFilterHolder = $('.quick-filter-holder'),
        quickFilterCalendarId = $quickFilterHolder.data('calendar-id'),
        quickFilterStorageKey = 'quickFilterValues_' + quickFilterCalendarId,
        quickFilterValues = [],
        quickFilterValuesLoaded = false;

    try {
        let storedQuickFilterValues = localStorage.getItem(quickFilterStorageKey);
        if (storedQuickFilterValues) {
            quickFilterValues = JSON.parse(storedQuickFilterValues);
        }
    } catch (e) {
        quickFilterValues = [];
    }

    function loadQuickFilterValues() {
        let $dropdown = $quickFilterHolder.find('.quick-filter-values');

        $.ajax({
            url: `/calendar/${quickFilterCalendarId}/quick-filter-values`,
            method: 'GET',
            success: function (res) {
                quickFilterValuesLoaded = true;

                if (!res || !res.values || !res.values.length) {
                    $dropdown.html('<div class="text-center text-muted small py-2">No values available</div>');
                    return;
                }

                let html = '';
                res.values.forEach(function (item) {
                    let checked = quickFilterValues.map(String).indexOf(String(item.value)) !== -1 ? 'checked' : '';
                    html += `<div class="quick-filter-option">
                                <label class="d-block mb-1">
                                    <input type="checkbox" class="quick-filter-checkbox" value="${item.value}" ${checked}>
                                    ${item.label}
                                </label>
                            </div>`;
                });

                $dropdown.html(html);
            },
            error: function () {
                $dropdown.html('<div class="text-center text-muted small py-2">Failed to load values</div>');
            }
        });
    }

    $(document).on('click', '.quick-filter-trigger', function () {
        if (!quickFilterValuesLoaded) {
            loadQuickFilterValues();
        }
    });

    $(document).on('click', '.quick-filter-apply', function () {
        quickFilterValues = $quickFilterHolder.find('.quick-filter-checkbox:checked').map(function () {
            return $(this).val();
        }).get();

        try {
            localStorage.setItem(quickFilterStorageKey, JSON.stringify(quickFilterValues));
        } catch (e) {
        }

        loaded_tasks = [];
        calendar.removeAllEvents();
        reloadCalendarData();
        $quickFilterHolder.removeClass('show').find('.dropdown-menu').removeClass('show');
    });

    $(document).on('click', '.quick-filter-reset', function () {
        quickFilterValues = [];
        $quickFilterHolder.find('.quick-filter-checkbox').prop('checked', false);

        try {
            localStorage.removeItem(quickFilterStorageKey);
        } catch (e) {
        }

        loaded_tasks = [];
        calendar.removeAllEvents();
        reloadCalendarData();
        $quickFilterHolder.removeClass('show').find('.dropdown-menu').removeClass('show');
    });

    let currentSearchQuery = '';

    $('#search-records[data-view="calendar"]').on('keyup', function () {
        currentSearchQuery = this.value.toLowerCase();
        calendar.rerenderEvents();
    });

    $body.on('click', '.cancel-calendar-save', function (e) {
        let table_id = $(this).data('table-id'),
            applied_filter = $(this).attr('data-filter') ? $(this).attr('data-filter') : '';
        if (applied_filter.length) {
            applied_filter = `?filter=${applied_filter}`;
        }
        window.location = `/browse/${table_id}/calendar${applied_filter}`;
    });

    $body.on('click', '.save-calendar', function (e) {
        let table_id = $(this).data('table-id'),
            error = false,
            payload = [],
            columns = [],
            view_name = $('#view-name').val(),
            start_date_field = $('#calendar-start-field').val(),
            end_date_field = $('#calendar-end-field').val(),
            all_day_field = $('#calendar-all-day-field').val(),
            default_users = $('#default-users').val(),
            filter = $('#calendar-filter').val(),
            colorize_by = $('#calendar-colorize-by').val(),
            colorize_border = $('#calendar-colorize-border').val(),
            quick_filter_field = $('#calendar-quick-filter-field').val(),
            start_time = '',
            end_time = '',
            $selected_columns = $('.selected-columns').find('.column');

        // Check if start field type is 'date', get and validate start time value
        if ($('#calendar-start-field option:selected').data('field-type') === 'date') {
            start_time = $('#calendar-day-start-time').val();
            if (!start_time.length) {
                alert('Please enter a valid start time');
                return;
            }
        }

        // Check if end field type is 'date', get and validate end time value
        if ($('#calendar-end-field option:selected').data('field-type') === 'date') {
            end_time = $('#calendar-day-end-time').val();
            if (!end_time.length) {
                alert('Please enter a valid end time');
                return;
            }
        }

        $selected_columns.each((i, $column) => {
            columns.push($($column).data('field-id'));
        });

        if (!view_name.length) {
            alert('Please enter calendar name');
            return;
        }

        if (!start_date_field.length) {
            alert('Select Start Date/Time field');
            return;
        }

        if (!end_date_field.length) {
            alert('Select End Date/Time field');
            return;
        }

        if (!$selected_columns.length) {
            alert('Select columns for filter');
            return;
        }

        if (!error) {
            $.ajax({
                method: 'POST',
                url: `/calendar/${table_id}`,
                data: {
                    payload: payload,
                    title: view_name,
                    columns: columns,
                    start_date_field: start_date_field,
                    end_date_field: end_date_field,
                    all_day_field: all_day_field,
                    default_users: default_users,
                    filter: filter,
                    colorize_by: colorize_by,
                    colorize_border: colorize_border,
                    quick_filter_field: quick_filter_field,
                    start_time: start_time,
                    end_time: end_time
                },
                success: function (res) {
                    if (res) {
                        window.location = `/browse/${table_id}/calendar`;
                    }
                }
            });
        }
    });

    $body.on('click', '.update-calendar', function (e) {
        let table_id = $(this).data('table-id'),
            id = $(this).data('id'),
            error = false,
            payload = [],
            columns = [],
            view_name = $('#view-name').val(),
            start_date_field = $('#calendar-start-field').val(),
            end_date_field = $('#calendar-end-field').val(),
            all_day_field = $('#calendar-all-day-field').val(),
            default_users = $('#default-users').val(),
            filter = $('#calendar-filter').val(),
            colorize_by = $('#calendar-colorize-by').val(),
            colorize_border = $('#calendar-colorize-border').val(),
            quick_filter_field = $('#calendar-quick-filter-field').val(),
            start_time = '',
            end_time = '',
            $selected_columns = $('.selected-columns').find('.column'),
            applied_filter = $(this).attr('data-filter');

        if (applied_filter.length) {
            applied_filter = `?filter=${applied_filter}`;
        }

        // Check if start field type is 'date', get and validate start time value
        if ($('#calendar-start-field option:selected').data('field-type') === 'date') {
            start_time = $('#calendar-day-start-time').val();
            if (!start_time.length) {
                alert('Please enter a valid start time');
                return;
            }
        }

        // Check if end field type is 'date', get and validate end time value
        if ($('#calendar-end-field option:selected').data('field-type') === 'date') {
            end_time = $('#calendar-day-end-time').val();
            if (!end_time.length) {
                alert('Please enter a valid end time');
                return;
            }
        }

        $selected_columns.each((i, $column) => {
            columns.push($($column).data('field-id'));
        });

        if (!view_name.length) {
            alert('Please enter calendar name');
            return;
        }

        if (!start_date_field.length) {
            alert('Select Start Date/Time field');
            return;
        }

        if (!end_date_field.length) {
            alert('Select End Date/Time field');
            return;
        }

        if (!$selected_columns.length) {
            alert('Select columns for filter');
            return;
        }

        if (!error) {
            $.ajax({
                method: 'POST',
                url: `/calendar/${table_id}/update`,
                data: {
                    id: id,
                    payload: payload,
                    title: view_name,
                    columns: columns,
                    start_date_field: start_date_field,
                    end_date_field: end_date_field,
                    all_day_field: all_day_field,
                    default_users: default_users,
                    filter: filter,
                    colorize_by: colorize_by,
                    colorize_border: colorize_border,
                    quick_filter_field: quick_filter_field,
                    start_time: start_time,
                    end_time: end_time
                },
                success: function (res) {
                    if (res) {
                        window.location = `/browse/${table_id}/calendar${applied_filter}`;
                    }
                }
            });
        }
    });

    $body.on('click', '#create-record[data-action="calendar"]', function (e) {
        let $form = $('.create-dialog-form')[0],
            id = $(this).attr('data-table-id'),
            primary_column = $(this).attr('data-primary-column'),
            $field = $('.create-modal-field'),
            $create_modal = $('#create-modal'),
            $create_body = $('#create-body'),
            // payload = $form.serializeArray(),
            $edit_icon = $field.siblings('.edit-relation'),
            url = '',
            action = $(this).attr('data-action'),
            mode = $(this).attr('data-mode'),
            record_id = $(this).attr('data-record-id'),
            $form_data = new FormData($form);

        $form_data.append('is_calendar', 1);
        tinymce.triggerSave(true, true);
        $create_modal.find(`.text-danger`).empty().addClass('d-none');

        if (!record_id.length) {
            url = `/savefield/${id}/dialog/${primary_column}`;
        } else {
            url = `/updatefield/${id}/dialog/${primary_column}`;
        }

        $.ajax({
            type: "POST",
            url: url,
            processData: false,
            contentType: false,
            cache: false,
            data: $form_data,
            success: function (res) {
                if (res) {
                    if (record_id.length) {
                        let event = calendar.getEventById(record_id);
                        if (event) {
                            event.remove();
                            loaded_tasks = loaded_tasks.filter(id => id !== parseInt(record_id));
                        }
                        reloadCalendarData();
                        $create_body.empty();
                        $create_modal.modal('hide');
                    } else {
                        window.location.reload();
                    }
                }
            },
            error: function (res) {
                let errors = res.responseJSON.errors;
                for (let key in errors) {
                    if (errors.hasOwnProperty(key)) {
                        $create_modal.find(`.text-danger[data-name="` + key + `"]`).text(errors[key]).removeClass('d-none');
                    }
                }
            }
        });
    });

    $(document).on('click', '.delete-calendar-record', function (e) {
        e.preventDefault();
        let record_id = $(this).attr('data-record-id'),
            table_id = $(this).attr('data-id'),
            $create_modal = $('#create-modal'),
            $create_body = $('#create-body');

        if (confirm(translation.confirm_delete_record)) {
            $.ajax({
                url: "/delete-multiple-fields",
                type: 'DELETE',
                data: {
                    ids: record_id,
                    id: table_id
                },
                success: function (data) {
                    var failed_ids = data.failed_ids,
                        removed_ids = data.removed_ids,
                        failed_urls = data.failed_urls;

                    if (failed_ids.length) {
                        toastr.error(
                            `<a href="${failed_urls[0]}"><button type="button" class="btn btn-sm btn-light w-100 mt-2"> ${translation.view_record} </button></a>`,
                            data['failed_message']
                        );
                    } else {
                        calendar.getEventById(record_id).remove();
                        $create_body.empty();
                        $create_modal.modal('hide');
                    }
                },
                error: function (data) {
                    alert(data.responseText);
                }
            });
        }
    });


    // On change event for the calendar-start-field
    $('#calendar-start-field').change(function () {
        const startFieldType = $('#calendar-start-field option:selected').data('field-type');
        if (startFieldType === 'date') {
            $('.start-time-holder').removeClass('d-none');
        } else {
            $('.start-time-holder').addClass('d-none');
        }
    });

    // On change event for the calendar-end-field
    $('#calendar-end-field').change(function () {
        const endFieldType = $('#calendar-end-field option:selected').data('field-type');
        if (endFieldType === 'date') {
            $('.end-time-holder').removeClass('d-none');
        } else {
            $('.end-time-holder').addClass('d-none');
        }
    });

    if ($('.create-update-fields').length) {
        let table = parseInt($('.edit-form').attr('data-id'));

        $.ajax({
            type: 'GET',
            url: `/calendar/${table}/fields`,
            success: function (res) {
                setupAllDayLogic(res);
            }
        });
    }

    function setupAllDayLogic(fields) {
        $(document).on('change', `input[name="${fields.all_day_field}"]`, function (e) {
            let date_format = $('meta[name="date-format"]').attr('content');
            date_format = date_format + " H:i";

            // Convert to Moment.js compatible format
            let momentFormat = date_format
                .replace('d', 'D')   // Day of the month, without leading zeros
                .replace('m', 'MM')   // Month, 1-12
                .replace('Y', 'YYYY')  // 4-digit year
                .replace('H', 'HH')  // Hours (24-hour), 00-23
                .replace('i', 'mm'); // Minutes, 00-59

            // If 'all_day' checkbox is checked
            if ($(this).is(':checked')) {
                // Get values from Flatpickr inputs
                let startDatetimeStr = $(`input[name="${fields.start_field}"]`).val();
                let endDatetimeStr = $(`input[name="${fields.end_field}"]`).val();

                // Parse dates using Moment.js and the specified format
                let startDatetime = startDatetimeStr ? moment(startDatetimeStr, momentFormat) : null;
                let endDatetime = endDatetimeStr ? moment(endDatetimeStr, momentFormat) : null;

                // Set to start and end of day if input values exist
                if (startDatetime) {
                    startDatetime.startOf('day');
                }

                if (endDatetime) {
                    endDatetime.endOf('day');
                }
                let start_value = '',
                    end_value = '';

                // Check if the dates are valid before setting them
                if (startDatetime && startDatetime.isValid()) {
                    start_value = startDatetime.format(momentFormat);
                } else {
                    start_value = moment().startOf('day').format(momentFormat);
                }

                if (endDatetime && endDatetime.isValid()) {
                    end_value = endDatetime.format(momentFormat);
                } else {
                    end_value = moment().endOf('day').format(momentFormat);
                }

                $(`input[name="${fields.start_field}"]`).attr('value', end_value).val(start_value).trigger('change');
                $(`input[name="${fields.end_field}"]`).attr('value', end_value).val(end_value).trigger('change');

            } else {
                // Logic for when 'all_day' checkbox is unchecked (if needed)
                // For example, reset input values or handle differently
            }
        });
    }

    if ($('#calendar').length) {
        tasks = JSON.parse($('#calendar').attr('data-records'));
        calendar_start_field = $('#calendar').attr('data-start-field'),
            calendar_end_field = $('#calendar').attr('data-end-field'),
            calendar_all_day_field = $('#calendar').attr('data-all-day-field'),
            initCalendarView();
    }

    $('.toggle-calendar').on('click', function (e) {
        e.preventDefault();
        $('.toggle-calendar').removeClass('checked');
        $('.toggle-calendar').find('.fa-check').addClass('d-none');
        $(this).addClass('checked');
        $(this).find('.fa-check').removeClass('d-none');
        task_type = $('.toggle-calendar.checked').attr('data-type');
        initCalendarView();
    });

    $('.create-calendar-task').on('click', function (e) {
       e.preventDefault();
       showEventCreateModal();
    });

    // Change view on select
    $('#view-switcher').on('change', function () {
        calendar.changeView($(this).val());
        localStorage.setItem('fcDefaultView', $(this).val());
    });

    // Single-day week view (weekday strip + selected day) for phones and narrow screens
    function isCompactWeekView() {
        return !!window.is_mobile || window.innerWidth < 768;
    }

    function initCalendarView() {
        console.log(window.is_mobile);
        if (calendar) {
            calendar.destroy();
        }
        $('#calendar').empty();
        compactWeekView = isCompactWeekView();
        let user_id = parseInt($('.toggle-calendar.checked').attr('data-user')),
            user_tasks = JSON.parse($('#calendar').attr('data-user-tasks'));
        defaultView = localStorage.getItem("fcDefaultView") ? localStorage.getItem("fcDefaultView") : 'dayGridMonth';
        let defaultStart = localStorage.getItem("fcDefaultStart") ? localStorage.getItem("fcDefaultStart") : moment(),
            defaultEnd = localStorage.getItem("fcDefaultEnd") ? localStorage.getItem("fcDefaultEnd") : moment(),
            month = localStorage.getItem("fcMonth") ? localStorage.getItem("fcMonth") : moment(),
            sidebar_default = localStorage.getItem("sideBarDefaultDate") ? localStorage.getItem("sideBarDefaultDate") : false,
            defaultDate = defaultStart,
            main_calendar_height = $(document).innerHeight() - 300,
            view = bsBreakpoints.detectBreakpoint();

        if (defaultView === 'dayGridMonth') {
            defaultDate = moment(month).startOf('month').format('YYYY-MM-DD');
        }

        $('#view-switcher').val(defaultView);

        const calendarHeader = window.is_mobile ? {
            left: 'prev',
            center: 'title',
            right: 'next'
        } : {
            left: 'prev,next today',
            center: 'title',
            right: 'listWeek,timeGridDay,timeGridWeek,dayGridMonth'
        };

        calendar = new Calendar(document.getElementById('calendar'), {
            aspectRatio: 1,
            header: calendarHeader,
            locales: [slLocale, hrLocale, fiLocale, svLocale, itLocale, csLocale, skLocale, frLocale],
            locale: locale,
            plugins: [listPlugin, dayGridPlugin, timeGridPlugin, interactionPlugin],
            editable: $('#calendar').attr('data-editable') === '1',
            droppable: true,
            defaultView: defaultView,
            defaultDate: defaultDate,
            visibleRange: {
                start: defaultStart,
                end: defaultEnd
            },
            weekNumbers: true,
            weekNumberCalculation: 'ISO',
            navLinks: true,
            views: {
                dayGridMonth: {
                    displayEventTime: false,
                    eventLimit: window.is_mobile ? 3 : 5,
                    eventLimitText: function (num) {
                        return '+' + num;
                    }
                },
                // On mobile/narrow screens the week view shows a strip with all weekdays on top (see renderWeekStrip)
                // and only the selected day in the grid; prev/next jump a whole week.
                // Desktop keeps the regular 7-day week grid.
                timeGridWeek: compactWeekView ? {
                    duration: {days: 1},
                    dateIncrement: {weeks: 1},
                    columnHeader: false,
                    buttonText: ({sl: slLocale, hr: hrLocale, fi: fiLocale, sv: svLocale, it: itLocale, cs: csLocale, sk: skLocale, fr: frLocale}[locale] || {buttonText: {week: 'week'}}).buttonText.week,
                    displayEventTime: true
                } : {
                    displayEventTime: true
                },
                timeGridDay: {
                    displayEventTime: true
                },
                listWeek: {
                    displayEventTime: true
                }
            },
            viewSkeletonRender: function (info) {
                localStorage.setItem("fcDefaultView", info.view.type);
                defaultView = info.view.type;
                console.log(info.view.type);
                $('#view-switcher').val(defaultView);
                // datesRender doesn't fire when switching views over the same date range
                renderWeekStrip(info.view);
                // if (defaultView !== 'dayGridMonth') {
                // clearSplitView();
                //     localStorage.setItem("sideBarDefaultDate", '');
                // }
            },
            height: window.is_mobile ? 'auto' : main_calendar_height,
            contentHeight: window.is_mobile ? 'auto' : (view === 'xSmall' || view === 'large' ? 520 : main_calendar_height),

            eventClick: function (info) {
                let $avatar = $(info.jsEvent.target).closest('.calendar-avatar');

                // On touch devices tapping an avatar shows the user's name instead of opening the record
                if ($avatar.length && isTouchDevice()) {
                    $('.calendar-avatar').not($avatar).tooltip('close');
                    $avatar.tooltip('open');
                    return;
                }

                showEventEditModal(info.event.extendedProps.task.id);

                // if (defaultView === 'dayGridMonth') {
                //     splitCalendarView();
                //     renderSubCalendar(info.event.start);
                //     localStorage.setItem("sideBarDefaultDate", moment(info.event.start).format('YYYY-MM-DD'));
                // } else {
                //     showEventEditModal(info.event);
                //     // window.location = info.event.extendedProps.itemUrl;
                // }
            },
            dateClick: function (info) {
                let target = $(info.jsEvent.target);

                if (target.hasClass('fc-day-number')) {
                    // ← Use timeGridDay on both, regardless of mobile
                    calendar.changeView('timeGridDay', info.date);

                    localStorage.setItem(
                        "sideBarDefaultDate",
                        moment(info.date).format('YYYY-MM-DD')
                    );
                } else {
                    console.log('Create event on:', info.date);
                    showEventCreateModal();
                }
            },
            navLinkDayClick: function (date, jsEvent) {
                calendar.changeView('timeGridDay', date);

                localStorage.setItem(
                    "sideBarDefaultDate",
                    moment(date).format('YYYY-MM-DD')
                );
            },
            windowResize: function () {
                // Rebuild when crossing the narrow/wide breakpoint so the week view switches layout
                if (isCompactWeekView() !== compactWeekView) {
                    initCalendarView();
                }
            },
            datesRender: function (info) {
                renderWeekStrip(info.view);
                reloadCalendarData();
            },

            eventResize: function (info) {
                let id = info.event.id,
                    start = moment(info.event.start).format('YYYY-MM-DD HH:mm:ss'),
                    end = getEventEndForSave(info.event);

                $.ajax({
                    type: 'POST',
                    url: '/tasks',
                    data: {
                        table_id,
                        id,
                        start,
                        end,
                        calendar_start_field,
                        calendar_end_field
                    },
                    success: function (res) {
                    },
                    error: function () {
                        info.revert();
                    }
                });
            },

            eventDrop: function (info) {

                let id = info.event.id,
                    start = moment(info.event.start).format('YYYY-MM-DD HH:mm:ss'),
                    end = getEventEndForSave(info.event),
                    type = info.view.type;

                updateTask(id, start, end);

                $.ajax({
                    type: 'POST',
                    url: '/tasks',
                    data: {
                        table_id,
                        id,
                        start,
                        end,
                        type,
                        calendar_start_field,
                        calendar_end_field
                    },
                    success: function (res) {
                    },
                    error: function () {
                        info.revert();
                    }
                });
            },
            eventRender: function (info) {

                let viewType = info.view.type;

                if (viewType === 'timeGridWeek' && !compactWeekView) {
                    $(info.el).find('.fc-time').remove();
                }

                if (viewType === 'timeGridDay' || (viewType === 'timeGridWeek' && compactWeekView)) {
                    $(info.el).find('.fc-time').show();
                }

                // Ensure minimum height
                requestAnimationFrame(() => {
                    let $el = $(info.el);
                    if ($el.height() < 15) {
                        $el.height(20);
                    }
                });

                let search = currentSearchQuery;

                if (info.isStart) {

                    let task = info.event.extendedProps.task,
                        firstField = info.event.extendedProps.titleField,
                        columns = JSON.parse($('#calendar').attr('data-columns'));

                    let fullText = (info.event.title || '');

                    if (task) {
                        fullText += ' ' + Object.keys(task)
                            .filter(key => key !== 'calendar_users')
                            .map(key => task[key])
                            .join(' ');
                    }

                    let users = (task && task.calendar_users) || {},
                        titleIndex = columns.indexOf(firstField),
                        $title = $(info.el).find('.fc-title, .fc-list-item-title a').first();

                    // Assign to / Multi-assign to placed before the title field are shown as avatars in front of the title,
                    // going backwards so prepending keeps the configured order
                    for (let i = columns.length - 1; i >= 0; i--) {
                        if (isAvatarColumn(columns[i]) && (titleIndex === -1 || i < titleIndex) && users[columns[i]]) {
                            $title.prepend(renderCalendarAvatars(users[columns[i]]));
                        }
                    }

                    let isMatch = search && fullText.toLowerCase().includes(search);

                    if (search) {
                        if (isMatch) {
                            $(info.el)
                                .addClass('fc-highlight-event')
                                .removeClass('fc-dim-event');
                        } else {
                            $(info.el)
                                .addClass('fc-dim-event')
                                .removeClass('fc-highlight-event');
                        }
                    } else {
                        $(info.el).removeClass('fc-highlight-event fc-dim-event');
                    }

                    // ✅ 👉 ONLY add custom multi-line content if NOT all-day
                    if (!info.event.allDay && task !== undefined) {

                        $(info.el).find('.fc-content').append('<div class="custom-text"></div>');

                        for (let i = 0; i < columns.length; i++) {
                            let prop = columns[i];

                            if (isAvatarColumn(prop)) {
                                // Avatars before the title are already in the title, no user assigned renders nothing
                                if (titleIndex !== -1 && i > titleIndex && users[prop]) {
                                    $(info.el)
                                        .find('.custom-text')
                                        .append($('<div style="padding: 2px;"></div>').append(renderCalendarAvatars(users[prop])));
                                }
                                continue;
                            }

                            if (
                                prop !== 'id' &&
                                task[prop] !== null &&
                                task.hasOwnProperty(prop) &&
                                prop !== firstField
                            ) {
                                $(info.el)
                                    .find('.custom-text')
                                    .append('<div style="padding: 2px;">' + task[prop] + '</div>');
                            }
                        }
                    }
                }
            },
            eventDestroy: function (info) {
                $(info.el).find('.calendar-avatar').tooltip('destroy');
            }
        });

        calendar.render();

        // $.each(tasks, function (i, task) {
        //     let skip_task = false;
        //     if (task_type === 'my_records' && !user_tasks.includes(task.id)) {
        //         skip_task = true;
        //     }
        //
        //     let start_date_time = task[calendar_start_field + '_start'],
        //         end_date_time = task[calendar_end_field + '_end'];
        //
        //     if (tenant === 'comtec') {
        //         start_date_time = `${task.start_date} ${task.start_time}`;
        //         end_date_time = `${task.end_date} ${task.end_time}`;
        //
        //         console.log(start_date_time, end_date_time);
        //     }
        //
        //     if (start_date_time &&
        //         end_date_time &&
        //         !skip_task
        //     ) {
        //         calendar.addEvent({
        //             id: task.id,
        //             title: getFirstField(task).value,
        //             start: moment(start_date_time).format(),
        //             end: moment(end_date_time).format(),
        //             itemUrl: `/edit-fields/${table_id}/${table_label}/${task.id}`,
        //             firstField: getFirstField(task).field,
        //             task: task.hasOwnProperty(calendar_all_day_field) && task[calendar_all_day_field] === 'on' ? task[0] : task,
        //             color: task.event_color,
        //             borderColor: task.border_color,
        //             allDay: task.hasOwnProperty(calendar_all_day_field) ? task[calendar_all_day_field] === 'on' : false
        //         });
        //     }
        // });

        // if (sidebar_default && defaultView === 'dayGridMonth') {
        //     splitCalendarView();
        //
        //     // sidebar should always display today's events
        //     // as requested in this task
        //     // https://app.asana.com/0/1129237646310738/1168803788786217/f
        //
        //     let sidebar_default = moment().format('YYYY-MM-DD');
        //     renderSubCalendar(sidebar_default);
        // }
    }


    // Google Calendar style weekday strip above the single-day grid of the week view
    function renderWeekStrip(view) {
        $('#calendar .fc-week-strip').remove();

        if (!compactWeekView || view.type !== 'timeGridWeek') {
            return;
        }

        let selected = moment(view.currentStart),
            weekDow = calendar.dateEnv.weekDow,
            weekStart = selected.clone().subtract((selected.day() - weekDow + 7) % 7, 'days'),
            today = moment().format('YYYY-MM-DD'),
            $strip = $('<div class="fc-week-strip"></div>');

        for (let i = 0; i < 7; i++) {
            let day = weekStart.clone().add(i, 'days'),
                date = day.format('YYYY-MM-DD'),
                $day = $('<button type="button" class="fc-week-strip-day"></button>')
                    .attr('data-date', date)
                    .append($('<span class="fc-week-strip-name"></span>').text(calendar.formatDate(day.toDate(), {weekday: 'short'})))
                    .append($('<span class="fc-week-strip-number"></span>').text(day.date()));

            if (date === selected.format('YYYY-MM-DD')) {
                $day.addClass('active');
            }

            if (date === today) {
                $day.addClass('today');
            }

            $strip.append($day);
        }

        $('#calendar .fc-view-container').before($strip);
    }

    $(document).on('click', '.fc-week-strip-day', function () {
        calendar.gotoDate($(this).attr('data-date'));
    });

    function reloadCalendarData() {
        let view = calendar.view;
        let start = moment(view.activeStart).format('YYYY-MM-DD'),
            end = moment(view.activeEnd).format('YYYY-MM-DD'),
            currentDate = calendar.getDate(),
            currentMonth = currentDate.getMonth(),
            month = moment().month(currentMonth).format('YYYY-MM-DD');

        localStorage.setItem("fcDefaultStart", start);
        localStorage.setItem("fcDefaultEnd", end);
        localStorage.setItem("fcMonth", month);

        let path = window.location.pathname,
            params = window.location.search,
            url = path + params,
            tasks_url = url.replace(/\/browse\//, '/tasks/'),
            task_type = $('.toggle-records.checked').attr('data-type');

        $.ajax({
            url: tasks_url,
            method: 'GET',
            data: {
                start: start,
                end: end,
                access: task_type,
                source: 'calendar',
                quick_filter_values: quickFilterValues.length ? JSON.stringify(quickFilterValues) : ''
            },
            success: function (response) {
                const delay = 0;
                addEventsWithDelay(response, delay, calendar)
                    .then(() => console.log('All events added successfully.'));
            },
            error: function (error) {
                console.error('Error fetching events:', error);
            }
        });
    }

    // FullCalendar ends all-day events exclusively, the record stores the last day itself
    function getEventEndForSave(event) {
        if (event.allDay && event.end) {
            return moment(event.end).subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss');
        }

        return moment(event.end || event.start).format('YYYY-MM-DD HH:mm:ss');
    }

    function addEventsWithDelay(events, delay, calendar) {
        return new Promise((resolve) => {
            async function addEvent(task) {
                // Add the event to FullCalendar
                let start_date_time = task[calendar_start_field + '_start'],
                    end_date_time = task[calendar_end_field + '_end'],
                    all_day = task.hasOwnProperty(calendar_all_day_field) ? task[calendar_all_day_field] === 'on' : false;

                if (tenant === 'comtec' || tenant === 'test0403') {
                    start_date_time = `${task.start_date} ${task.start_time}`;
                    end_date_time = `${task.end_date} ${task.end_time}`;
                }

                if (start_date_time &&
                    end_date_time &&
                    !loaded_tasks.includes(task.id)
                ) {
                    loaded_tasks.push(task.id);

                    let end = moment(end_date_time);

                    // Include the end date itself, FullCalendar would stop the event a day earlier
                    if (all_day) {
                        end = end.add(1, 'day').startOf('day');
                    }

                    await calendar.addEvent({
                        id: task.id,
                        title: getFirstField(task).value,
                        titleField: getFirstField(task).field,
                        start: moment(start_date_time).format(),
                        end: end.format(),
                        itemUrl: `/edit-fields/${table_id}/${table_label}/${task.id}`,
                        firstField: 'subject',
                        task: task.hasOwnProperty(calendar_all_day_field) && task[calendar_all_day_field] === 'on' ? task : task,
                        color: task.event_color,
                        borderColor: task.border_color,
                        allDay: all_day
                    });
                }
            }

            async function processEvents() {
                for (const event of events) {
                    await addEvent(event);
                    await new Promise((resolve) => setTimeout(resolve, delay));
                }

                resolve();
            }


            // Start processing the events
            processEvents();
        });
    }

    function showEventEditModal(event_id) {
        let $create_modal = $('#create-modal'),
            $modal_title = $('#create-title'),
            $create_body = $('#create-body'),
            $button_container = $('.create-modal-buttons'),
            $create_btn = $('#create-record'),
            url = `/edit-fields/${table_id}/${event_id}/dialog`;

        // If modal is already open, reset and close it first
        if ($create_modal.hasClass('show')) {
            $create_body.empty();
            $button_container.empty();
            $('#open-record').attr('href', '').addClass('d-none');

            $create_modal.modal('hide');
        }

        $create_btn.attr('data-table-id', table_id);
        $create_btn.attr('data-primary-column', 0);
        $create_btn.attr('data-action', 'calendar');
        $create_btn.text(translation.update);
        $modal_title.text(translation.edit_record);
        $create_btn.attr('data-record-id', event_id);

        $.ajax({
            type: 'GET',
            url: url,
            success: function (res) {
                $create_body.empty().html(res.view);
                $button_container.empty().html(res.buttons).removeClass('d-none');

                $('#open-record')
                    .attr('href', res.url)
                    .removeClass('d-none');

                $create_modal.modal('show');

                $('.form-group .form-control').each(function () {
                    $(this).floatingLabel('ChangeFortText');
                });

                window.initCreateEditFormFields($create_body);
                window.initDialogRelatedSections($create_body);
                window.initTinyMce();
            }
        });
    }

    window.showEventEditModal = showEventEditModal;

    function showEventCreateModal() {
        let $create_modal = $('#create-modal'),
            $modal_title = $('#create-title'),
            $create_body = $('#create-body'),
            $button_container = $('.create-modal-buttons'),
            $open_record_btn = $('#open-record'),
            $create_btn = $('#create-record'),
            url = `/create/${table_id}/dialog`;

        $open_record_btn.addClass('d-none');
        $create_btn.attr('data-table-id', table_id);
        $create_btn.attr('data-primary-column', 0);
        $create_btn.attr('data-action', 'calendar');
        $create_btn.attr('data-record-id', '');
        $create_btn.text(translation.create);
        $modal_title.text(translation.create_record);

        $.ajax({
            type: 'GET',
            url: url,
            success: function (res) {
                $create_body.empty().html(res);
                $button_container.empty();
                $create_modal.modal('show');
                $('.form-group .form-control').each(function () {
                    $(this).floatingLabel('ChangeFortText');
                });

                window.initCreateEditFormFields($create_body);
                window.initTinyMce();
            }
        })
    }

    function getFirstField(task) {
        let columns = JSON.parse($('#calendar').attr('data-columns'));

        for (let i = 0; i < columns.length; i++) {
            let prop = columns[i];

            // Assign to / Multi-assign to are rendered as avatars, never as the event title
            if (prop !== 'id' && !isAvatarColumn(prop) && task.hasOwnProperty(prop)) {
                return task[prop] === null ? 'N/A' : {
                    field: prop,
                    value: task[prop]
                };
            }
        }
        return '';
    }

    function isAvatarColumn(prop) {
        return prop === 'assigned_to' || prop === 'multi_assigned_to';
    }

    function isTouchDevice() {
        return window.matchMedia('(hover: none)').matches;
    }

    // Overlapping avatars (profile picture or initials) with the user's full name on hover/tap,
    // at most 3 followed by +N for the remaining users
    function renderCalendarAvatars(users) {
        const max = 3;
        // $.fn.tooltip is the jQuery UI widget here, not Bootstrap's
        let $holder = $('<span class="calendar-avatars"></span>'),
            tooltip = {position: {my: 'center bottom-6', at: 'center top'}};

        users.slice(0, max).forEach(function (user) {
            let $avatar = $('<span class="calendar-avatar"></span>').attr('title', user.name);

            if (user.picture) {
                $avatar.addClass('has-picture').css('background-image', `url("${user.picture}")`);
            } else {
                $avatar.text(user.initials);
            }

            $holder.append($avatar.tooltip(tooltip));
        });

        if (users.length > max) {
            let $more = $('<span class="calendar-avatar calendar-avatar-more"></span>')
                .text('+' + (users.length - max))
                .attr('title', users.slice(max).map(user => user.name).join(', '));

            $holder.append($more.tooltip(tooltip));
        }

        return $holder;
    }

    // Tapping anywhere outside an avatar closes its name tooltip
    $(document).on('touchstart', function (e) {
        if (!$(e.target).closest('.calendar-avatar').length) {
            $('.calendar-avatar').tooltip('close');
        }
    });

    // function renderSubCalendar(defaultDate) {
    //     $('#sub-calendar').empty();
    //     let user_tasks = JSON.parse($('#calendar').attr('data-user-tasks'));
    //     let defaultView = $('#sub-calendar').attr('data-view');
    //
    //     let sub_calendar = new Calendar(document.getElementById('sub-calendar'), {
    //         eventTextColor: '#000000',
    //         header: false,
    //         locales: [slLocale, hrLocale],
    //         locale: locale,
    //         plugins: [listPlugin, dayGridPlugin, timeGridPlugin, interactionPlugin, momentPlugin],
    //         editable: true,
    //         droppable: true,
    //         defaultView: defaultView,
    //         defaultDate: defaultDate,
    //         columnHeaderText: function (date) {
    //             return moment(date).locale(locale).format('dddd LL');
    //         },
    //         listDayFormat: 'dddd LL',
    //         height: $('.main-calendar').find('.fc-view-container').innerHeight(),
    //         eventClick: function (info) {
    //             showEventEditModal(info.event);
    //             // window.location = info.event.extendedProps.itemUrl;
    //         },
    //         eventRender: function (info) {
    //
    //             if (info.isStart) {
    //                 let task = info.event.extendedProps.task,
    //                     firstField = info.event.extendedProps.titleField,
    //                     columns = JSON.parse($('#calendar').attr('data-columns'));
    //
    //                 if (task !== undefined) {
    //                     $(info.el).find('.fc-content').append('<div class="custom-text"></div>');
    //
    //                     // Loop over columns instead of task properties
    //                     for (let i = 0; i < columns.length; i++) {
    //                         let prop = columns[i];
    //
    //                         if (prop !== 'id' &&
    //                             task[prop] !== null &&
    //                             task.hasOwnProperty(prop) &&
    //                             prop !== firstField
    //                         ) {
    //                             $(info.el).find('.custom-text').append('<div style="padding: 2px;">' + task[prop] + '</div>');
    //                         }
    //                     }
    //                 }
    //             }
    //         },
    //         eventResize: function (info) {
    //             let id = info.event.id,
    //                 start = moment(info.event.start).format('YYYY-MM-DD HH:mm:ss'),
    //                 end = moment(info.event.end || info.event.start).format('YYYY-MM-DD HH:mm:ss');
    //
    //             updateTask(id, start, end, 'sidebar');
    //
    //             $.ajax({
    //                 type: 'POST',
    //                 url: '/tasks',
    //                 data: {
    //                     table_id,
    //                     id,
    //                     start,
    //                     end,
    //                     calendar_start_field,
    //                     calendar_end_field
    //                 },
    //                 success: function (res) {
    //                 }
    //             });
    //         },
    //         eventDrop: function (info) {
    //
    //             let id = info.event.id,
    //                 start = moment(info.event.start).format('YYYY-MM-DD HH:mm:ss'),
    //                 end = moment(info.event.end || info.event.start).format('YYYY-MM-DD HH:mm:ss'),
    //                 type = info.view.type;
    //
    //             updateTask(id, start, end, 'sidebar');
    //
    //             $.ajax({
    //                 type: 'POST',
    //                 url: '/tasks',
    //                 data: {
    //                     table_id,
    //                     id,
    //                     start,
    //                     end,
    //                     type,
    //                     calendar_start_field,
    //                     calendar_end_field
    //                 },
    //                 success: function (res) {
    //                 }
    //             });
    //         },
    //         datesRender: function (info) {
    //             let start = moment(info.view.activeStart).format('YYYY-MM-DD'),
    //                 end = moment(info.view.activeEnd).format('YYYY-MM-DD'),
    //                 month = moment().month(info.view.title).format('YYYY-MM-DD');
    //
    //             localStorage.setItem("fcDefaultStart", start);
    //             localStorage.setItem("fcDefaultEnd", end);
    //             localStorage.setItem("fcMonth", month);
    //
    //             sub_calendar.removeAllEvents();
    //
    //             let path = window.location.pathname,
    //                 params = window.location.search,
    //                 url = path + params,
    //                 tasks_url = url.replace(/\/browse\//, '/tasks/'),
    //                 task_type = $('.toggle-records.checked').attr('data-type');
    //
    //             $.ajax({
    //                 url: tasks_url,
    //                 method: 'GET',
    //                 data: {
    //                     start: start,
    //                     end: end,
    //                     access: task_type,
    //                     source: 'sub_calendar'
    //                 },
    //                 success: function (response) {
    //                     // // Assuming the backend responds with an array of events in the response
    //
    //                     $(response).each(function (index, task) {
    //                         let start_date_time = task[calendar_start_field + '_start'],
    //                             end_date_time = task[calendar_end_field + '_end'];
    //
    //                         if (tenant === 'comtec' || tenant === 'test0403') {
    //                             start_date_time = `${task.start_date} ${task.start_time}`;
    //                             end_date_time = `${task.end_date} ${task.end_time}`;
    //                         }
    //
    //                         sub_calendar.addEvent({
    //                             id: task.id,
    //                             title: getFirstField(task).value,
    //                             titleField: getFirstField(task).field,
    //                             start: moment(start_date_time).format(),
    //                             end: moment(end_date_time).format(),
    //                             itemUrl: `/edit-fields/${table_id}/${table_label}/${task.id}`,
    //                             firstField: getFirstField(task).field,
    //                             task: task.hasOwnProperty(calendar_all_day_field) && task[calendar_all_day_field] === 'on' ? task[0] : task,
    //                             color: task.event_color,
    //                             borderColor: task.border_color,
    //                             allDay: task.hasOwnProperty(calendar_all_day_field) ? task[calendar_all_day_field] === 'on' : false
    //                         });
    //                     })
    //                 },
    //                 error: function (error) {
    //                     console.error('Error fetching events:', error);
    //                 }
    //             });
    //         }
    //     });
    //
    //     sub_calendar.render();
    //
    //     $.each(tasks, function (i, task) {
    //         let skip_task = false;
    //         if (task_type === 'my_records' && !user_tasks.includes(task.id)) {
    //             skip_task = true;
    //         }
    //
    //         let start_date_time = task[calendar_start_field + '_start'],
    //             end_date_time = task[calendar_end_field + '_end'];
    //
    //         if (tenant === 'comtec') {
    //             start_date_time = `${task.start_date} ${task.start_time}`;
    //             end_date_time = `${task.end_date} ${task.end_time}`;
    //         }
    //
    //         if (start_date_time &&
    //             end_date_time &&
    //             !skip_task
    //         ) {
    //             sub_calendar.addEvent({
    //                 id: task.id,
    //                 title: getFirstField(task).value,
    //                 start: moment(start_date_time).format(),
    //                 end: moment(end_date_time).format(),
    //                 url: `/edit-fields/${table_id}/${table_label}/${task.id}`,
    //                 firstField: getFirstField(task).field,
    //                 task: task.hasOwnProperty(calendar_all_day_field) && task[calendar_all_day_field] === 'on' ? task[0] : task,
    //                 color: task.event_color,
    //                 borderColor: task.border_color,
    //                 allDay: task.hasOwnProperty(calendar_all_day_field) ? task[calendar_all_day_field] === 'on' : false
    //             });
    //         }
    //     });
    // }
    //
    // function splitCalendarView() {
    //     let view = bsBreakpoints.detectBreakpoint(),
    //         $calendar = $('.main-calendar'),
    //         $side_calendar = $('.side-calendar'),
    //         height = $calendar.find('.fc-toolbar').innerHeight(),
    //         margin = $calendar.find('.fc-toolbar').outerHeight();
    //
    //     $calendar.removeClass('col-12');
    //
    //     switch (view) {
    //         case 'xLarge':
    //             $calendar.addClass('col-9');
    //             $side_calendar.addClass('col-3');
    //             break;
    //         case 'large':
    //             $calendar.addClass('col-7');
    //             $side_calendar.addClass('col-5');
    //             break;
    //         case 'medium':
    //             $calendar.addClass('col-12');
    //             $side_calendar.addClass('col-12');
    //             break;
    //         case 'small':
    //             $calendar.addClass('col-12');
    //             $side_calendar.addClass('col-12');
    //             break;
    //         case 'xSmall':
    //             $calendar.addClass('col-12');
    //             $side_calendar.addClass('col-12');
    //             break;
    //     }
    //
    //     $side_calendar.removeClass('d-none');
    //
    //     if (view === 'xLarge' || view === 'large') {
    //         $side_calendar.find('.fc-view-container').css({'margin-top': height + margin + 'px'})
    //     }
    // }
    //
    // function clearSplitView() {
    //     let $calendar = $('.main-calendar'),
    //         $side_calendar = $('.side-calendar');
    //
    //     $calendar.removeClass().addClass('col-12').addClass('main-calendar');
    //     $side_calendar.removeClass().addClass('d-none').addClass('side-calendar');
    // }

    function updateTask(id, start, end, trigger = null) {
        for (let i = 0; i < tasks.length; i++) {
            if (tasks[i].id === parseInt(id)) {
                if (tenant === 'comtec') {
                    tasks[i].start_datetime = start;
                    tasks[i].end_datetime = end;

                    let start_date = moment(start).format('YYYY-MM-DD'),
                        start_time = moment(start).format('HH:mm:ss'),
                        end_date = moment(end).format('YYYY-MM-DD'),
                        end_time = moment(end).format('HH:mm:ss');

                    console.log(start_date, start_time, end_date, end_time);

                    tasks[i].start_date = start_date;
                    tasks[i].start_time = start_time;
                    tasks[i].end_date = end_date;
                    tasks[i].end_time = end_time;
                } else {
                    tasks[i].start_datetime = start;
                    tasks[i].end_datetime = end;
                }
            }
        }

        // if (trigger === 'sidebar') {
        //     let calendar_event = calendar.getEventById(id);
        //     calendar_event.setDates(start, end);
        //     // initCalendarView();
        // } else {
        //     if (localStorage.getItem("sideBarDefaultDate") && defaultView === 'dayGridMonth') {
        //         splitCalendarView();
        //         renderSubCalendar(localStorage.getItem("sideBarDefaultDate"));
        //     }
        // }
    }
});